"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
function findAndParseKeywords(xml) {
    var _a;
    if ((0, utils_1.hasTag)(xml, "ows:Keywords")) {
        return (0, utils_1.findTagArray)(xml, "ows:Keyword");
    }
    // example: <Keywords>municipalities, colombia, boundaries</Keywords>
    return ((_a = (0, utils_1.findTagText)(xml, "Keywords")) === null || _a === void 0 ? void 0 : _a.split(", ")) || [];
}
exports.default = findAndParseKeywords;
